import { useCallback, useEffect } from "react";
import useDrivePicker from "react-google-drive-picker";

export default function useGoogleDriveImagePicker({ isEditing, setFormData, setFormDataEdit, setError, isHotel = false }) {
    const [openPicker, authResponse] = useDrivePicker();
    useEffect(() => {
        if (authResponse?.access_token && isTokenExpired()) {
            localStorage.setItem("googlePickerToken", authResponse?.access_token);
            const expiresIn = 3600;
            const expiryTime = Date.now() + expiresIn * 1000;
            localStorage.setItem("googleTokenExpiry", expiryTime.toString());
        }
    }, [authResponse]);
    const isTokenExpired = () => {
        const expiryTime = localStorage.getItem("googleTokenExpiry");
        if (!expiryTime) return true;
        return Date.now() >= parseInt(expiryTime, 10);
    };
    const handleOpenPicker = useCallback((targetField = "coverImage") => {

        let savedToken = isTokenExpired() ? localStorage.removeItem("googlePickerToken") : localStorage.getItem("googlePickerToken");
        openPicker({
            clientId: "665871621059-8bc6dvm02m30is6v2keo1vvu0skn2kop.apps.googleusercontent.com",
            developerKey: "AIzaSyA5hoUZ1VwLIL1OitJrBBzt6LMOQ0gMbQs",
            viewId: "DOCS_IMAGES",
            token: savedToken,
            showUploadFolders: true,
            supportDrives: true,
            multiselect: false,
            setIncludeOAuthToken: true,
            setOAuthToken: true,
            callbackFunction: async (data) => {
                let accessToken =
                    data?.oauthToken ||
                    authResponse?.access_token ||
                    localStorage.getItem("googlePickerToken");

                if (data.action === 'picked' && data.docs && data.docs.length > 0 && accessToken) {
                    const fileId = data.docs[0].id;
                    const fileName = data.docs[0].name || "image.jpg";
                    const downloadUrl = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;

                    try {
                        const response = await fetch(downloadUrl, {
                            headers: {
                                Authorization: `Bearer ${accessToken}`,
                            },
                        });

                        if (!response.ok) throw new Error("Unable to download image from Google Drive. Please check sharing permissions.");
                        const blob = await response.blob();
                        const file = new File([blob], fileName, { type: blob.type });

                        const maxSize = 5 * 1024 * 1024;
                        if (blob.size > maxSize) {
                            setError("Selected file is too large. Maximum allowed size is 5MB.");
                            return;
                        }

                        if (isEditing) {
                            isHotel ? setFormDataEdit((prev) => ({ ...prev, [targetField]: [file] })) : setFormDataEdit((prev) => ({ ...prev, [targetField]: file }));
                        } else {
                            isHotel ? setFormData((prev) => ({ ...prev, [targetField]: [file] })) : setFormData((prev) => ({ ...prev, [targetField]: file }));
                        }
                    } catch (err) {
                        setError("Failed to download image from Google Drive. Please make sure the file is shared or try another image.");
                    }
                }
                if (data.action === 'picked' && data.docs && data.docs.length > 0 && !accessToken) {
                    // Remove any possibly invalid token
                    localStorage.removeItem("googlePickerToken");
                    localStorage.removeItem("googleTokenExpiry");
                    setError("Google authentication failed or expired. Please log in to Google Drive again.");
                    return;
                }
            },
        });

    }, [authResponse, openPicker]);

    return handleOpenPicker;

}